import { Colors } from "../preset.constants";

export const checkboxPreset = {
    background: Colors.PrimaryBackground,
    border: {
        color: Colors.SuccessColor
    },
    disabled: {
        background: Colors.DisabledBackground,
        color: Colors.DisabledColor
    }
}